import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import OfferAssetItemComponent from './OfferAssetItemComponent';
import { RightsContext } from 'providers/RightsContext';
import { getAssetHierarchyImage } from 'features/asset/hierarchy/selectors';

export const OfferAssetListComponent = ({ assets, onEdit, assetImages, assetTypes, onDeleteAsset, deleting }) => {
  const { financedAssetWrite } = useContext(RightsContext);
  
  return assets.map((asset, idx) => (
    <OfferAssetItemComponent
      key={asset.documentDetailId || asset.assetTypeName}
      idx={idx}
      deleting={deleting}
      showDeleteButton={assets.length > 1 && !!financedAssetWrite}
      onDeleteAsset={onDeleteAsset}
      asset={asset}
      onEdit={onEdit}
      assetImage={
        getAssetHierarchyImage(asset.hierarchy, assetImages) ?? assetTypes.find(x => x.assetTypeId === asset.assetTypeId)?.imageUrl
      }
    />
  ));
};

OfferAssetListComponent.propTypes = {
  assets: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDeleteAsset: PropTypes.func.isRequired,
  assetImages: PropTypes.object.isRequired,
  assetTypes: PropTypes.array.isRequired,
  deleting: PropTypes.bool.isRequired
};

export default OfferAssetListComponent;
